var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('v-container',{class:( _obj = { 'pa-6': !_vm.data.staticClass }, _obj[_vm.data.staticClass] = !!_vm.data.staticClass, _obj )},[_vm._t("append"),_c('base-slow-connection',{attrs:{"isLoading":_vm.props.isLoading,"noDescription":_vm.props.noDescription}},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }